import React from 'react';
import PropTypes from 'prop-types';
const Moment = require('moment');
import { Row } from 'react-bootstrap';
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const ShortCourseActions = require('../../actions/ShortCourseActions');
import DateString from '../common/DateString';
import UserDisplayName from '../user/UserDisplayName';
import StatTile from '../tiles/StatTile';

const propTypes = {
    shortCourseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    shortCourseStoreState: PropTypes.object.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: ''
};

class ShortCourseDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.refreshShortCourseSaves = this.refreshShortCourseSaves.bind(this);
    }

    componentDidMount() {
        this.refreshShortCourseSaves(this.props.shortCourseId);
    }

    componentDidUpdate(prevProps) {
        // TODO: this will be true twice during switch from parent component
        if (
            (this.props.shortCourseId !== prevProps.shortCourseId)
            && !this.props.shortCourseStoreState.saves
        ) {
            this.refreshShortCourseSaves(this.props.shortCourseId);
        }
    }

    refreshShortCourseSaves(shortCourseId) {
        ShortCourseActions.getShortCourseSaves(uuid.v4(), { shortCourseId: shortCourseId });
    }

    render() {
        if (
            !this.props.shortCourseStoreState.initialized
        ) {
            return null;
        }

        const shortCourse = this.props.shortCourseStoreState.shortCourse;
        if (!shortCourse) {
            console.warn(`ShortCourse ${this.props.shortCourseId} not found in store.`);
            return null;
        }

        let lastPublishedDate = 0; // moment eqiv. for epoch time
        let foundLastPublished = false;
        if (this.props.shortCourseStoreState.saves) {
            this.props.shortCourseStoreState.saves.forEach((save) => {
                if (save.published_on && Moment(save.published_on) > Moment(lastPublishedDate)) {
                    foundLastPublished = true;
                    lastPublishedDate = save.published_on;
                }
            });
        }

        return (
            <Row className={`${this.props.className}`}>
                <StatTile
                    className="text-centered border-right col-6 col-sm-4 col-lg-3"
                    term={Strings['en'].common.CREATED}
                >
                    <DateString shortMonth date={shortCourse.created_at} />
                </StatTile>
                <StatTile
                    className="text-centered border-right col-6 col-sm-4 col-lg-2"
                    term={Strings['en'].common.MODIFIED}
                >
                    <DateString shortMonth date={shortCourse.modified_at} />
                </StatTile>
                <StatTile
                    className="text-centered border-right col-6 col-sm-4 col-lg-2"
                    term={Strings['en'].short_course.LAST_PUBLISHED}
                >
                    { foundLastPublished ?
                        <DateString shortMonth date={lastPublishedDate} />
                        :
                        Strings['en'].common.NEVER
                    }
                </StatTile>
                <StatTile
                    className="text-centered border-right col-6 col-sm-4 col-lg-3"
                    term={Strings['en'].common.AUTHOR}
                >
                    <UserDisplayName id={shortCourse.channel_id} />
                </StatTile>
                <StatTile
                    className="text-centered border-right col-6 col-sm-4 col-lg-2"
                    term={Strings['en'].short_course.CURRENT_VERSION}
                >
                    {shortCourse.latest_version}
                </StatTile>
            </Row>
        )
    }
}

ShortCourseDetails.propTypes = propTypes;
ShortCourseDetails.defaultProps = defaultProps;

export default ShortCourseDetails;